import { Address, LoqateAddress } from '../../types/passport';

const addCommaIfRequired = (field: string) => {
  if (field) return `${field}, `;
  return ``;
};

const getFormattedAddress = (passportAddress: Address) => {
  const { flat, houseNumber, houseName, town, county, street, postcode } = passportAddress;
  return `${addCommaIfRequired(flat)}${addCommaIfRequired(houseNumber)}${addCommaIfRequired(
    houseName,
  )}${addCommaIfRequired(street)}${addCommaIfRequired(town)}${addCommaIfRequired(county)}${postcode}`;
};

const getFormattedYearsMonths = (passportAddress: Address) => {
  const { yearsAtAddress, monthsAtAddress } = passportAddress;
  let yearText = 'Years';
  let monthText = 'Months';
  if (parseInt(yearsAtAddress, 10) === 1) yearText = 'Year';
  if (parseInt(monthsAtAddress, 10) === 1) monthText = 'Month';
  if (parseInt(monthsAtAddress, 10) === 12) return `(${parseInt(yearsAtAddress, 10) + 1} ${yearText})`;

  return `(${yearsAtAddress} ${yearText} ${monthsAtAddress} ${monthText})`;
};

const getFormattedStreetFromLoquate = (details: LoqateAddress) => {
  const streetArr = [];
  if (details.Company) streetArr.push(details.Company);
  if (details.Street) streetArr.push(details.Street);
  if (details.SecondaryStreet) streetArr.push(details.SecondaryStreet);
  if (details.Block) streetArr.push(details.Block);
  if (details.Neighbourhood) streetArr.push(details.Neighbourhood);
  if (details.District) streetArr.push(details.District);
  return streetArr && streetArr.length > 0 ? streetArr.join(', ') : '';
};

const getFormattedHouseNumberFromLoquate = (details: LoqateAddress) => {
  return !details.SubBuilding && !details.BuildingNumber ? details.BuildingName : details.BuildingNumber;
};

const getFormattedHouseNameFromLoquate = (details: LoqateAddress) => {
  return !details.SubBuilding && !details.BuildingNumber ? '' : details.BuildingName;
};

export {
  getFormattedYearsMonths,
  getFormattedAddress,
  addCommaIfRequired,
  getFormattedStreetFromLoquate,
  getFormattedHouseNumberFromLoquate,
  getFormattedHouseNameFromLoquate,
};
